module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Black + Cognac Open.5a4c9e26.png";